export const API_KEY = '415cb159f652a615867f0132b7101fa3';
export const url = 'https://gateway.marvel.com/v1/public/characters';
